var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"el-zoom-in-top"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"generalTip1",attrs:{"role":"status"}},[_c('div',{staticClass:"generalTip",class:_vm.positive ? 'generalTip_b' : 'generalTip_r'},[_c('p',[_vm._v(_vm._s(_vm.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }